module.exports = __webpack_public_path__ + "1686a0c1f1e64f61c9d26c4bf8c8b942.svg";